import React, { useState } from 'react';
import Webcam from 'react-webcam';
import Popup from 'reactjs-popup';

import "./Button.css"
import "./Height.css"
// var Upload = require('rc-upload');


const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};

function Height() {
  const [image, setImg] = useState(0);
  const [showImg, setShowImg] = React.useState(0)

  let webcam;

  if (showImg == 1) {
    webcam = <><img src={image} />
      <div class="container">
        <button class="button" onClick={() => { setShowImg(0) }}>Retake</button>
        <button class="button" onClick={() => {
          setShowImg(2);
          const timer = setTimeout(() => {
            setShowImg(3);
          }, 1500);
        }}>Confirm</button>
      </div>
    </>
  } else if (showImg == 0) {
    webcam = <>        <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Height Increaser </strong> </div>
        <div className="content">
          {' '}
          According to a study in the Journal of Applied Psychology, a 6-foot tall person earns $166,000 more on average during a 30-year career than someone who is 5 foot-5. This is true controlling for gender, age, and weight.
          <br />
          <br />
          Our society is influenced by many subconscious associations that affect our lives every day. Two people subject to different kinds of subconscious associations might have entirely different perspectives on human nature.
          <br />
          <br />
          This next app is a portal into an alternative universe - one where the user is taller, and reaps the societal benefits of being perceived as such. Take an image of yourself, and see how your whole world changes.
          <br />
          <br />
          <a href="https://www.apa.org/monitor/julaug04/standing">https://www.apa.org/monitor/julaug04/standing</a>
          <br />
          <br />
          <a style={{fontWeight: "bold"}}>Be sure to take a full-body image!</a> 

        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>
<Webcam
      audio={false}
      height={720}
      screenshotFormat="image/jpeg"
      width={1280}
      videoConstraints={videoConstraints}
    >
      {({ getScreenshot }) => (
        <button class="button"
          onClick={() => {
            setImg(getScreenshot());
            setShowImg(1);
          }}
        >
          Take Photo
        </button>
      )}
    </Webcam>
    </>
  } else if (showImg == 2) {
    webcam = <p>
      Making you taller...
    </p>
  } else if (showImg == 3) {
    webcam = <>
      <p>
        This is what you would look like if you were taller. Making more money yet?
      </p>
      <img class="stretched-img" src={image} />
    </>

  }

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Height Increaser
        </p>

        {webcam}

      </header>
    </div>
  );
}

export default Height;
